import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import "../styles/custombtn.css";
import Resume from "../assets/files/Simon_Carrier_Resume.pdf";
import computer from "../assets/images/computer.jpg";

function Home(props) {
  return (
    <>
      <Container>
        <Row className="justify-content-md-center">
          <Col style={{ padding: "1rem", paddingTop: "10rem" }} xs={12} md={6}>
            <h1>
              Hi, I'm <span style={{ color: "purple" }}>Simon.</span>
            </h1>
            <br />
            <hr style={{ color: "purple" }} />
            <p style={{ fontSize: "1.5rem" }}>
              {" "}
              I'm a Quebec based{" "}
              <em style={{ color: "purple" }}>
                self-taught Software Engineer.
              </em>
              <br />
              Feel free to browse my work, or click the button below to download
              my cv.
            </p>
            <a
              className="btn btn-cust text-white"
              href={Resume}
              download
              target="_blank"
            >
              Download CV
            </a>
          </Col>
          <Col xs={12} md={6} style={{ paddingTop: "5rem" }}>
            <Image src={computer} fluid rounded />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Home;
